export default {
  LOGIN: '/auth/login'
}
